export function buildQuery(queryData: Record<string, string>): string {
  if (!queryData) {
    return '';
  }

  return Object.entries(queryData)
    .filter(([_, query]) => !!query)
    .map(([key, query]) => `${key}: ${query}`)
    .join(' ');
}

export const buildPageQuery = ({
  page,
  fragments,
  additionalQueries,
}: {
  page?: string;
  fragments?: string[];
  additionalQueries?: string;
}) => {
  if (!page) {
    console.warn(
      "[DotCMS Client]: No page query was found, so we're loading all content using _map. This might slow things down. For better performance, we recommend adding a specific query in the page attribute."
    );
  }

  return `
  fragment DotCMSPage on DotPage {
    publishDate
    type
    httpsRequired
    inode
    path
    identifier
    hasTitleImage
    sortOrder
    extension
    canRead
    pageURI
    canEdit
    archived
    friendlyName
    workingInode
    url
    pageURI
    hasLiveVersion
    deleted
    pageUrl
    shortyWorking
    mimeType
    locked
    stInode
    contentType
    creationDate
    liveInode
    name
    shortyLive
    modDate
    title
    baseType
    working
    canLock
    live
    isContentlet
    statusIcons
    canEdit
    canLock
    canRead
    canEdit
    canLock
    canRead
    runningExperimentId
    urlContentMap {
      ... on Blog{
       _map
       blogContent{
        blogContent : json
       }
      }
    }
    host {
      identifier
      hostName
     	googleMap
      archived
      contentType
    }
    vanityUrl {
      action
      forwardTo
      uri
    }
    conLanguage {
      id
      language
      languageCode
    }
    template {
      drawed
      anonymous
      theme
      identifier
    }
    containers {
      path
      identifier
      maxContentlets
      containerStructures {
        id
        code
        structureId
        containerId
        contentTypeVar
        containerInode
      }
      containerContentlets {
        uuid
        contentlets {
          ${page ? DEFAULT_PAGE_CONTENTLETS_CONTENT : '_map'}
        }
      }
    }
    layout {
      header
      footer
      body {
        rows {
          styleClass
          columns {
            leftOffset
            styleClass
            width
            left
            containers {
              identifier
              uuid
            }
          }
        }
      }
    }
    viewAs {
      visitor {
        persona {
          modDate
          inode
          name
          identifier
          keyTag
          photo {
            versionPath
          }
        }
      }
      persona {
        modDate
        inode
        name
        identifier
        keyTag
        photo {
         versionPath
        }
      }
      language {
        id
        languageCode
        countryCode
        language
        country
      }
    }
  }

  ${page ? ` fragment ClientPage on DotPage { ${page} } ` : ''}

  ${fragments ? fragments.join('\n\n') : ''}

  query PageContent($url: String!, $languageId: String, $mode: String, $personaId: String, $fireRules: Boolean, $publishDate: String, $siteId: String, $variantName: String) {
    page: page(url: $url, languageId: $languageId, pageMode: $mode, persona: $personaId, fireRules: $fireRules, publishDate: $publishDate, site: $siteId, variantName: $variantName) {
      ...DotCMSPage
      ${page ? '...ClientPage' : ''}
    }

    ${additionalQueries}
  }
  `;
};

const DEFAULT_PAGE_CONTENTLETS_CONTENT = `
          publishDate
          inode
          identifier
          archived
          urlMap
          urlMap
          locked
          contentType
          creationDate
          modDate
          title
          baseType
          working
          live
          publishUser {
            firstName
            lastName
          }
          owner {
            lastName
          }
          conLanguage {
            language
            languageCode
          }
          modUser {
            firstName
            lastName
          }
`;
